import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { PlusSquare } from "react-feather";

//Forms
import UpdateCompanyNameForm from "./UpdateCompanyDetailsForm";

interface ModalProps {
  company_code: string;
  company_name: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateCompanyNameModal: React.FC<ModalProps> = ({
  company_code,
  company_name,
  modal,
  toggle,
}) => {
  return (
    <>
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Company Information</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>
          <UpdateCompanyNameForm
            toggle={toggle}
            company_code={company_code}
            company_name={company_name}
          />
        </div>
      </Modal>
    </>
  );
};
export default UpdateCompanyNameModal;
